export const WIDGET_CONFIGS = {
    'dashboard': {
        type: 'dashboard',
        title: 'Real-Time Intelligence Dashboard',
        description: 'Live metrics and KPI tracking with customizable charts',
        icon: '📊',
        category: 'analytics',
        defaultSize: { width: 4, height: 3 },
        minSize: { width: 3, height: 2 },
        maxSize: { width: 6, height: 4 },
        resizable: true,
        configurable: true,
    },
    'tasks-table': {
        type: 'tasks-table',
        title: 'Tasks Table',
        description: 'Detailed table view of all your assigned tasks',
        icon: '📋',
        category: 'productivity',
        defaultSize: { width: 6, height: 4 },
        minSize: { width: 4, height: 3 },
        resizable: true,
        configurable: true,
    },
    'tasks-calendar': {
        type: 'tasks-calendar',
        title: 'Tasks Calendar',
        description: 'Calendar view of tasks and deadlines',
        icon: '📅',
        category: 'productivity',
        defaultSize: { width: 4, height: 4 },
        minSize: { width: 3, height: 3 },
        resizable: true,
        configurable: true,
    },
    'quick-stats': {
        type: 'quick-stats',
        title: 'Quick Stats',
        description: 'Overview cards showing key metrics',
        icon: '📈',
        category: 'analytics',
        defaultSize: { width: 4, height: 2 },
        minSize: { width: 3, height: 1 },
        maxSize: { width: 6, height: 2 },
        resizable: true,
        configurable: false,
    },
    'activity-feed': {
        type: 'activity-feed',
        title: 'Activity Feed',
        description: 'Recent activity and updates from your workspace',
        icon: '🔔',
        category: 'collaboration',
        defaultSize: { width: 3, height: 4 },
        minSize: { width: 2, height: 3 },
        resizable: true,
        configurable: true,
    },
    'recent-boards': {
        type: 'recent-boards',
        title: 'Recent Boards',
        description: 'Quick access to your most recently used boards',
        icon: '📌',
        category: 'productivity',
        defaultSize: { width: 3, height: 3 },
        minSize: { width: 2, height: 2 },
        resizable: true,
        configurable: false,
    },
    'team-overview': {
        type: 'team-overview',
        title: 'Team Overview',
        description: 'Team members status and availability',
        icon: '👥',
        category: 'collaboration',
        defaultSize: { width: 3, height: 3 },
        minSize: { width: 2, height: 2 },
        resizable: true,
        configurable: true,
    },
    'goals-tracker': {
        type: 'goals-tracker',
        title: 'Goals Tracker',
        description: 'Track progress towards your objectives',
        icon: '🎯',
        category: 'productivity',
        defaultSize: { width: 3, height: 3 },
        minSize: { width: 2, height: 2 },
        resizable: true,
        configurable: true,
        premium: true,
    },
    'time-tracker': {
        type: 'time-tracker',
        title: 'Time Tracker',
        description: 'Track time spent on tasks and projects',
        icon: '⏱️',
        category: 'productivity',
        defaultSize: { width: 2, height: 2 },
        minSize: { width: 2, height: 1 },
        resizable: true,
        configurable: true,
        premium: true,
    },
    'notifications': {
        type: 'notifications',
        title: 'Notifications',
        description: 'Recent notifications and alerts',
        icon: '🔔',
        category: 'utilities',
        defaultSize: { width: 2, height: 3 },
        minSize: { width: 2, height: 2 },
        resizable: true,
        configurable: true,
    },
    'weather': {
        type: 'weather',
        title: 'Weather',
        description: 'Current weather and forecast',
        icon: '🌤️',
        category: 'utilities',
        defaultSize: { width: 2, height: 2 },
        minSize: { width: 2, height: 1 },
        resizable: false,
        configurable: true,
    },
    'clock': {
        type: 'clock',
        title: 'World Clock',
        description: 'Time zones for global team coordination',
        icon: '🕐',
        category: 'utilities',
        defaultSize: { width: 2, height: 2 },
        minSize: { width: 2, height: 1 },
        resizable: false,
        configurable: true,
    },
    'notes': {
        type: 'notes',
        title: 'Quick Notes',
        description: 'Sticky notes for quick thoughts and reminders',
        icon: '📝',
        category: 'utilities',
        defaultSize: { width: 2, height: 2 },
        minSize: { width: 2, height: 2 },
        resizable: true,
        configurable: false,
    },
    'bookmarks': {
        type: 'bookmarks',
        title: 'Bookmarks',
        description: 'Quick access to your favorite links and resources',
        icon: '🔖',
        category: 'utilities',
        defaultSize: { width: 2, height: 3 },
        minSize: { width: 2, height: 2 },
        resizable: true,
        configurable: false,
    },
    'app-widget': {
        type: 'app-widget',
        title: 'App Widget',
        description: 'Widget from any app in the ecosystem',
        icon: '🎨',
        category: 'utilities',
        defaultSize: { width: 3, height: 3 },
        minSize: { width: 2, height: 2 },
        maxSize: { width: 6, height: 5 },
        resizable: true,
        configurable: true,
    },
    'vision-board-overview': {
        type: 'vision-board-overview',
        title: 'Vision Board Overview',
        description: 'View all your ranges and mountains at a glance',
        icon: '👁️',
        category: 'productivity',
        defaultSize: { width: 4, height: 4 },
        minSize: { width: 3, height: 3 },
        maxSize: { width: 6, height: 5 },
        resizable: true,
        configurable: true,
    },
    'vision-mountains-list': {
        type: 'vision-mountains-list',
        title: 'Mountains & Goals',
        description: 'Track your goals with progress indicators',
        icon: '🏔️',
        category: 'productivity',
        defaultSize: { width: 3, height: 4 },
        minSize: { width: 2, height: 3 },
        resizable: true,
        configurable: true,
    },
    'vision-goals-summary': {
        type: 'vision-goals-summary',
        title: 'Goals Summary',
        description: 'Statistics on your vision board goals',
        icon: '📊',
        category: 'analytics',
        defaultSize: { width: 2, height: 2 },
        minSize: { width: 2, height: 2 },
        resizable: true,
        configurable: false,
    },
    'vision-mountain-detail': {
        type: 'vision-mountain-detail',
        title: 'Goal Deep Dive',
        description: 'Detailed view of a specific goal with all steps',
        icon: '🎯',
        category: 'productivity',
        defaultSize: { width: 4, height: 4 },
        minSize: { width: 3, height: 3 },
        resizable: true,
        configurable: true,
    },
    'vision-daily-plan': {
        type: 'vision-daily-plan',
        title: 'Vision Board Daily Plan',
        description: 'Today\'s goals and tasks from your vision board',
        icon: '📅',
        category: 'productivity',
        defaultSize: { width: 6, height: 6 },
        minSize: { width: 3, height: 4 },
        maxSize: { width: 6, height: 8 },
        resizable: true,
        configurable: true,
    },
};
export const DEFAULT_WIDGETS = [
// Start with empty workspace - let users add widgets as needed
];
export const GRID_COLS = 6;
export const GRID_ROWS = 8;
export const WIDGET_MARGIN = 16;
